import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Card, Col, Divider, Form, Input, message, Popover, Row, Table, Tabs } from 'antd';

import moment from 'moment';
import util from '@util/index';
import {
  queryApportionList,
  queryApportionToNo,
  queryApportionToRestore,
  querySaveApportionDetail,
} from '@api/finance/apportion';
import { connect } from 'react-redux';
import YearPicker from '@comm/YearPicker';
import Statistic from '@comm/statistic/Index';
import { setBackInfo } from '@store/modules/back_info';
import ModalApportion from '@comm/apportion/ModalApportion2';
import { queryDictExpend } from '@api/core/dict';

const FormItem = Form.Item;
const { TabPane } = Tabs;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expendType: [],
      statistics: {},
      data: [],
      dataNo: [],
      isLoading: true,
      isNo: 0,
      year: '',
      total: 0,
      totalNo: 0,
      pageNo: 1,
      pageNoNo: 1,
      visible: false,
      dataInfo: {
        apportion: {},
      },
    };
  }

  componentDidMount() {
    const { backInfo } = this.props;
    this.loadExpendType();
    if (backInfo.path === this.props.location.pathname) {
      this.setState(
        {
          isNo: backInfo.isNo,
          year: backInfo.year,
          pageNo: backInfo.pageNo,
          pageNoNo: backInfo.pageNoNo,
          condition: backInfo.condition,
        },
        () => {
          backInfo.isNo === 0 && this.loadData();
          backInfo.isNo === 1 && this.loadNoData();
        },
      );
    } else {
      this.loadData(1);
      this.setState({
        year: moment.unix(Date.now() / 1000).format('YYYY'),
      });
    }
  }

  componentWillUnmount() {
    const { isNo, year, pageNo, pageNoNo, condition } = this.state;
    const params = {
      path: this.props.location.pathname,
      isNo,
      year,
      pageNo,
      pageNoNo,
      condition,
    };
    this.props.dispatch(setBackInfo(params));
  }

  loadExpendType = () => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });
  };

  findTypeName = type => {
    let typeName = '';
    this.state.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  // 加载需分摊数据
  loadData = pageNo => {
    const params = {};
    const context = this;
    const { condition, year } = this.state;
    const no = this.state.pageNoNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    params.year = year || moment.unix(Date.now() / 1000).format('YYYY');
    params.isNo = 0;
    this.setState({
      pageNo: current,
      isLoading: true,
    });
    queryApportionList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          statistics: res.data.statistics,
          data: res.data.list,
          total: res.totalSize,
          isLoading: false,
          currentTotal: res.data.currentTotal,
        });
      }
    });
  };

  // 加载不分摊数据
  loadNoData = pageNoNo => {
    const params = {};
    const context = this;
    const { condition, year } = this.state;
    const no = this.state.pageNoNo;
    const current = pageNoNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    params.isNo = 1;
    params.year = year || moment.unix(Date.now() / 1000).format('YYYY');
    this.setState({
      pageNoNo: current,
      isLoading: true,
    });
    queryApportionList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          statistics: res.data.statistics,
          dataNo: res.data.list,
          totalNo: res.totalSize,
          isLoading: false,
          currentTotalNo: res.data.currentTotal,
        });
      }
    });
  };

  handleSubmit = e => {
    const { isNo } = this.state;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.condition,
          },
          () => {
            if (isNo === 0) {
              this.loadData(1);
            } else if (isNo === 1) {
              this.loadNoData(1);
            }
          },
        );
      }
    });
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleOk = params => {
    const { isNo } = this.state;
    this.apportion = params;
    this.handleVisible(false);
    this.saveApportionDetail(this.apportionUuid, params.details);
    if (isNo === 0) {
      this.loadData();
    } else if (isNo === 1) {
      this.loadNoData();
    }
  };

  // 改变年份
  changeYear = value => {
    const { isNo } = this.state;
    this.setState(
      {
        year: value,
      },
      () => {
        if (isNo === 0) {
          this.loadData(1);
        } else if (isNo === 1) {
          this.loadNoData(1);
        }
      },
    );
  };

  // 是否分摊列表切换
  changeIsNo = key => {
    this.setState({
      isNo: +key,
    });

    if (key === '0') {
      this.loadData();
    } else if (key === '1') {
      this.loadNoData();
    }
  };

  // 恢复分摊
  toRestore = uuid => {
    queryApportionToRestore({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message, 2.5);
        this.loadData();
        this.loadNoData();
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 不分摊
  toNo = uuid => {
    queryApportionToNo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message, 2.5);
        this.loadData();
        this.loadNoData();
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  saveApportionDetail = (uuid, params) => {
    querySaveApportionDetail(uuid, params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  handleAddRecord = params => {
    this.apportionUuid = params.uuid;
    this.setState({
      dataInfo: {
        type: params.budgetType,
        apportion: {
          type: params.type,
        },
      },
    });
    this.handleVisible(true);
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    const {
      backInfo: { path, year },
    } = this.props;
    let defaultYear = moment.unix(Date.now() / 1000).format('YYYY');
    if (path === this.props.location.pathname) {
      defaultYear = year;
    }
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
          <YearPicker
            defaultValue={defaultYear}
            style={{ width: '120px', marginRight: 8 }}
            onChange={this.changeYear}
          />
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="请输入关键字" />)}
          </FormItem>
          <FormItem>
            <Button htmlType="submit">查询</Button>
          </FormItem>
        </Form>
      </div>
    );
  };

  columns = () => {
    return [
      {
        title: '分摊编号',
        dataIndex: 'unid',
      },
      {
        title: '预算科目',
        dataIndex: 'budgetType',
        render: text => <span>{this.findTypeName(text)}</span>,
      },
      {
        title: '用款说明',
        dataIndex: 'remark',
        width: 300,
        render: text => {
          const content = <span>{text}</span>;
          return (
            <Popover content={content}>
              <p
                style={{
                  width: '300px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  marginBottom: 0,
                }}
              >
                {text}
              </p>
            </Popover>
          );
        },
      },
      {
        title: '预算发生时间',
        dataIndex: 'updateTime',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '发生金额',
        dataIndex: 'price',
      },

      {
        title: '待分摊金额',
        dataIndex: 'balance',
        render: text => {
          return <span>{text}</span>;
        },
      },
      {
        title: '操作',
        dataIndex: 'itemType',
        render: (text, record) => {
          // itemType 0：草稿，1：正常数据，2：失效数据,3:已分摊
          return (
            <span>
              {record.itemType === 0 ? (
                <Link to={`/finance/e_manage/open/${record.itemUuid}`}>报销明细</Link>
              ) : null}
              {record.itemType === 1 ? (
                <Link to={`/finance/p_manage/open/${record.itemUuid}`}>付款明细</Link>
              ) : null}
              {record.itemType === 2 ? (
                <Link to={`/finance/l_manage/open/${record.itemUuid}`}>借款明细</Link>
              ) : null}
              {record.itemType === 0 || record.itemType === 1 || record.itemType === 2 ? (
                <Divider type="verticle" />
              ) : null}
              {this.state.isNo === 0 ? (
                <Link to={`/finance/apportion/record/${record.uuid}`}>分摊记录</Link>
              ) : null}

              {this.state.isNo === 0 ? <Divider type="verticle" /> : null}
              {record.status === 1 ? (
                <a onClick={() => this.handleAddRecord(record)}>编辑分摊</a>
              ) : null}
              {record.status === 1 ? <Divider type="verticle" /> : null}
              {this.state.isNo ? (
                <a onClick={() => this.toRestore(record.uuid)}>恢复分摊</a>
              ) : (
                <a onClick={() => this.toNo(record.uuid)}>不分摊</a>
              )}
            </span>
          );
        },
      },
    ];
  };

  setClassName = record => {
    if (record.status !== 1) {
      return 'td-gray';
    }
  };

  render() {
    const {
      statistics,
      data,
      dataNo,
      isLoading,
      total,
      totalNo,
      isNo,
      pageNo,
      pageNoNo,
      visible,
      dataInfo,
      expendType,
    } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const paginationNo = {
      showSizeChanger: false,
      pageSize: 15,
      total: totalNo,
      current: pageNoNo,
      onChange: current => {
        this.loadNoData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <Row style={{ paddingBottom: '20px' }}>
            <Col span={13} />
            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
        </div>
        <Statistic
          data={[
            {
              title: '发生总金额',
              value: util.numberFormat(statistics.sum || 0),
            },
            {
              title: '待分摊金额',
              value: util.numberFormat(statistics.todo || 0),
            },
            {
              title: '已分摊金额',
              value: util.numberFormat(statistics.done || 0),
            },
            {
              title: '不分摊金额',
              value: util.numberFormat(statistics.no || 0),
            },
          ]}
        />
        <Tabs defaultActiveKey="0" activeKey={`${isNo}` || '0'} onChange={this.changeIsNo}>
          <TabPane tab="需分摊" key="0">
            <Table
              rowKey="uuid"
              loading={isLoading}
              columns={this.columns()}
              dataSource={data}
              pagination={pagination}
              rowClassName={this.setClassName}
            />
          </TabPane>
          <TabPane tab="不分摊" key="1">
            <Table
              rowKey="uuid"
              loading={isLoading}
              columns={this.columns()}
              dataSource={dataNo}
              pagination={paginationNo}
              rowClassName={this.setClassName}
            />
          </TabPane>
        </Tabs>
        <ModalApportion
          onCancel={this.handleVisible}
          dataInfo={{}}
          dataItem={dataInfo}
          visible={visible}
          onOk={this.handleOk}
          expendType={expendType}
        />
      </Card>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create({ wrappedComponentRef: true })(Index));



// WEBPACK FOOTER //
// ./src/components/finance/apportion/Index.js